import { defineStore } from 'pinia'
import {
  getRestaurantCode,
  getStatusWork,
  getRestaurantTitle,
  getIdByCode
} from './../api'
import { IGetNamePayload, IRestWork } from './types'
import { Redirect } from '@shared/model/types'
import { ref } from '@nuxtjs/composition-api'
import { Cookie } from '@shared/lib'
import { retryOnNetworkError } from '@shared/api'

export const useRestaurantModel = defineStore('restaurant', () => {
  const code = ref<string>('')
  const advanceCheckType = ref<string>('')
  const stubTypes = ref<string[]>([])
  const showModal = ref<boolean>(false)
  const restId = ref<number | null>(null)
  const tableCode = ref<string>('')
  const isCartEnabled = ref<boolean>(false)
  const isPreliminaryCheckOfIntent = ref<string>('')
  const isEmailRequired = ref<boolean>(false)
  const isCartCreateOrder = ref<boolean>(false)
  const isVisaBannerEnabled = ref<boolean>(false)

  // Получение кода ресторана
  const getCode = async (payload: IGetNamePayload) => {
    const { platform, externalId, qrType, timeout } = payload
    code.value = externalId
    if (qrType && qrType === 'precheck2') {
      // В precheck2 externalId — не код ресторана; пустой код значит «ещё не определён»
      code.value = ''
      const restaurant = await getRestaurantCode(platform, externalId, timeout)
      code.value = restaurant.code
      advanceCheckType.value = restaurant.advance_check_type
    }
    return code.value
  }

  // Получения статуса, работает ресторан или нет
  // С timeout запрос повторяется один раз при таймауте или обрыве сети
  const getStatus = async (payload: { restaurant: string; tableId: string; timeout?: number }) => {
    const { restaurant, tableId, timeout } = payload
    const res: IRestWork = timeout
      ? await retryOnNetworkError(() => getStatusWork(restaurant, tableId, timeout))
      : await getStatusWork(restaurant, tableId)
    stubTypes.value = res.stub_types
    tableCode.value = res.tableCode
    isCartEnabled.value = res.is_cart_enabled
    isPreliminaryCheckOfIntent.value = res.is_preliminary_check_of_intent
    isEmailRequired.value = res.is_email_required
    isCartCreateOrder.value = res.is_cart_create_order
    isVisaBannerEnabled.value = Boolean(res.is_visa_banner_enabled)
  }

  // Мета для заголовка страницы
  const getMetaDesription = async (timeout?: number) => {
    const title = await getRestaurantTitle(code.value, timeout)
    return `Оплати, пожалуйста, мой счет в ресторане ${title}`
  }

  // проверка ID реста на null
  const chekRestId = (id: string, fullPath: string, redirect: Redirect) => {
    if (!id) {
      return ''
    }
    // Если код стола === Null редиректим на старый стол который сохранили
    if (id.toLowerCase() === 'null') {
      const oldTableCode: string | undefined | null = Cookie.get('tableCode')
      if (!oldTableCode) { return '' }
      const newPath = fullPath.replace(/null/gi, oldTableCode)
      redirect(newPath)
    }
  }

  // Получение ID реста
  const getIdRestByCode = async (code: string, timeout?: number) => {
    const id = timeout
      ? await retryOnNetworkError(() => getIdByCode(code, timeout))
      : await getIdByCode(code)
    restId.value = id
  }

  return {
    code,
    restId,
    advanceCheckType,
    stubTypes,
    getCode,
    tableCode,
    getStatus,
    getMetaDesription,
    chekRestId,
    showModal,
    getIdRestByCode,
    isCartEnabled,
    isPreliminaryCheckOfIntent,
    isEmailRequired,
    isCartCreateOrder,
    isVisaBannerEnabled
  }
})
